import { Table as TableAtom } from 'antd';
import styled from 'styled-components';

export const Table = styled(TableAtom)`
  margin: 1rem;
  margin-top: 0;
  border: none;
  max-height: 21rem;
  overflow: auto;

  .ant-table.ant-table-bordered > .ant-table-container {
    border: none;
  }

  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr:not(:last-child)
    > th {
    background: var(--coolest-gray-30) !important;
    font-weight: var(--heading-6-weight) !important;
    font-weight: var(--heading-6-weight) !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid var(--gray-10) !important;
  }

  .ant-table-thead > tr > th {
    background: var(--coolest-gray-20);
    border-bottom: none;
    padding: 0.5rem;
    color: var(--gray-80);
    color: var(--gray-80);
  }

  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > tbody
    > tr
    > td {
    border-right: none;
  }

  .ant-table-tbody > tr > td {
    border: none;
    padding: 0.5rem;

    &:hover {
      cursor: pointer;
    }
  }

  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr
    > th {
    border-right: solid 1px var(--gray-10);
  }
`;
